import { render, staticRenderFns } from "./View_Main.vue?vue&type=template&id=09e5b626&"
import script from "./View_Main.vue?vue&type=script&lang=js&"
export * from "./View_Main.vue?vue&type=script&lang=js&"
import style0 from "./View_Main.vue?vue&type=style&index=0&id=09e5b626&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports